export const REFERRALS_COOKIE_HAS_PURCHASED = 'maker-attn-has-purchased'

export const REFERRALS_STORAGE_BUBBLE_HIDDEN = 'maker-referrals-bubble-hidden'
